// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_NORMAL_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updateNormalClaimPin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_NORMAL_PIN
});

export const updateNormalClaimApplyTravel = applyTravel => ({
    applyTravel,
    type: actions.UPDATE_CLAIM_NORMAL_APPLY_TRAVEL
});

export const updateNormalClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_NORMAL_WORK_ORDER_ONE,
    workOrder
});

export const updateNormalClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_NORMAL_WORK_ORDER_TWO,
    workOrder
});

export const updateNormalClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_NORMAL_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_NORMAL_OWNERSHIP_STATUS
});

export const updateNormalClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_NORMAL_FAILURE_PART
});

export const updateNormalClaimFailureRemanIndicator = remanIndicator => ({
    remanIndicator,
    type: actions.UPDATE_CLAIM_NORMAL_REMAN_INDICATOR
});

export const updateNormalClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_NORMAL_FAILURE_DATE
});

export const updateNormalClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_NORMAL_REPAIR_DATE
});

export const updateNormalClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_NORMAL_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateNormalClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_NORMAL_USE_AMOUNT
});

export const updateNormalClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_NORMAL_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetNormalClaim = () => ({
    type: actions.RESET_CLAIM_NORMAL
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_NORMAL_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/claim-details.js